import { apiProvider } from './api';
import { PLANNED_ORDER_SERVICE_JOB as NAME } from '../../constants';
import { router } from './router';
import PlannedOrderServiceJobTable from './Card.vue';

export const PlannedOrderServiceJob = {
	name: NAME,
	apiProvider,
	router,
	components: {
		PlannedOrderServiceJobTable,
	},
};
